export function SEOVisibility() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            SEO Visibility System
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive search optimization designed to put your business in front of customers actively looking for your services
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {[
            {
              icon: 'ri-map-pin-2-line',
              title: 'Local Search Visibility',
              desc: 'Dominate local search results for your service area and appear when nearby customers search',
              color: 'from-red-500 to-orange-500'
            },
            {
              icon: 'ri-file-text-line',
              title: 'Service Page Optimization',
              desc: 'Each service gets dedicated optimization to rank for specific customer searches',
              color: 'from-blue-500 to-blue-600'
            },
            {
              icon: 'ri-layout-grid-line',
              title: 'Content Architecture',
              desc: 'Strategic content structure that search engines understand and reward',
              color: 'from-purple-500 to-purple-600'
            },
            {
              icon: 'ri-robot-line',
              title: 'AI Search Compatibility',
              desc: 'Optimized for ChatGPT, Perplexity, and other AI engines that answer customer questions',
              color: 'from-teal-500 to-cyan-500'
            },
            {
              icon: 'ri-mic-line',
              title: 'Voice Search Readiness',
              desc: 'Structured to appear in voice assistant results when customers ask questions',
              color: 'from-green-500 to-emerald-500'
            },
            {
              icon: 'ri-line-chart-line',
              title: 'Visibility Growth Tracking',
              desc: 'Regular reporting on ranking improvements and search performance metrics',
              color: 'from-orange-500 to-red-500'
            }
          ].map((item, index) => (
            <div key={index} className="group">
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border-2 border-gray-200 hover:border-teal-500 transition-all h-full shadow-lg hover:shadow-xl">
                <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-10 text-white">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-teal-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-focus-3-line text-white text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-2">Measurable</h3>
              <p className="text-gray-300">Track your visibility growth with clear metrics</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-teal-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-2">Ongoing</h3>
              <p className="text-gray-300">Continuous optimization as search evolves</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-teal-500 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-white text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-2">Results-Driven</h3>
              <p className="text-gray-300">Focused on rankings that bring customers</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}